import { createSelector } from '@reduxjs/toolkit';
import memoize from 'lodash/memoize';
import moment from 'moment';

import { State } from './types';
import { RootState } from '../root-reducer';
import { SectionName, Section } from '../../../types/index';
import { serviceTypesSelector } from '../service-types/selectors';

export const rootSelector = (state: RootState): State => state.UserInfo;

export const statusSelector = createSelector(rootSelector, (state) => state.status);
export const errorSelector = createSelector(rootSelector, (state) => state.error);
export const dataSelector = createSelector(rootSelector, (state) => state.data);

export const isTemporarySelector = createSelector(dataSelector, (data) => data?.isTemporary);

export const fullNameSelector = createSelector(dataSelector, (data) => `${data?.firstName} ${data?.lastName}`);

export const userNameSelector = createSelector(dataSelector, (data) => data?.userName);

export const isUpcomingPasswordExpirySelector = createSelector(dataSelector, (data) => {
  if (data?.passwordExpiryDate) {
    const expiryDate = moment(data?.passwordExpiryDate).startOf('day');
    const today = moment().startOf('day');
    const difference = expiryDate.diff(today, 'days');

    return difference <= 5;
  } else {
    return false;
  }
});

// PROFILE ACCESS (replaces old "isAdmin"). Send String of specific section as argument to obtain ready or write access.
// see SectionName type for list of accepted Strings.

export const hasReadAccess = memoize((param?: SectionName) =>
  createSelector(dataSelector, (data) => {
    const userSection: Section | undefined = data?.profile?.sections.find((section) => section?.name === param);
    if (userSection?.read === true) return true;
    return false;
  })
);

export const hasWriteAccess = memoize((param?: SectionName) =>
  createSelector(dataSelector, (data) => {
    const userSection: Section | undefined = data?.profile?.sections.find(
      (section: Section) => section?.name === param
    );
    if (userSection?.write === true) return true;
    return false;
  })
);

export const getActifUserServiceTypesSelector = createSelector(
  dataSelector,
  serviceTypesSelector,
  (userInfo, serviceTypes) => {
    return serviceTypes.filter((item) => userInfo?.serviceTypeIDs.includes(item.id));
  }
);
